const EMatrixLogo = ({ size = 'default', showText = true }) => {
  const sizes = {
    small: { logo: 32, text: 'text-lg' },
    default: { logo: 48, text: 'text-2xl' },
    large: { logo: 64, text: 'text-3xl' },
  };
  
  const { logo: logoSize, text: textSize } = sizes[size] || sizes.default;
  const color = '#0D2440'; // e-Matrix dark blue
  
  return (
    <div className="flex items-center gap-3">
      {/* Use the uploaded logo image */}
      <img 
        src="https://customer-assets.emergentagent.com/job_employee-sync-tool/artifacts/sopccl7w_e-Matrix_Logo_nur_e.jpg"
        alt="e-Matrix Logo"
        width={logoSize}
        height={logoSize}
        style={{ objectFit: 'contain' }}
      />
      
      {/* e-Matrix text */}
      {showText && (
        <span 
          className={`${textSize} font-semibold tracking-tight`} 
          style={{ color }}
        >
          e-Matrix
        </span>
      )}
    </div>
  );
};

export default EMatrixLogo;
